export type ValidationType =
  | 'required'
  | 'email'
  | 'minLength'
  | 'maxLength'
  | 'min'
  | 'max'
  | 'pattern'
  | 'custom';

export interface ValidationRule {
  type: ValidationType;
  message: string;
  value?: any;
  validator?: (value: any, formData?: Record<string, any>) => boolean;
}

export const validateField = (
  value: any,
  rules: ValidationRule[],
  formData?: Record<string, any>
): string | null => {
  for (const rule of rules) {
    switch (rule.type) {
      case 'required':
        if (!value || (Array.isArray(value) && value.length === 0)) {
          return rule.message;
        }
        break;

      case 'email':
        const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (value && !emailPattern.test(value)) {
          return rule.message;
        }
        break;

      case 'minLength':
        if (value && value.length < rule.value) {
          return rule.message;
        }
        break;

      case 'maxLength':
        if (value && value.length > rule.value) {
          return rule.message;
        }
        break;

      case 'min':
        if (value && Number(value) < rule.value) {
          return rule.message;
        }
        break;

      case 'max':
        if (value && Number(value) > rule.value) {
          return rule.message;
        }
        break;

      case 'pattern':
        if (value && !new RegExp(rule.value).test(value)) {
          return rule.message;
        }
        break;

      case 'custom':
        if (rule.validator && value && !rule.validator(value, formData)) {
          return rule.message;
        }
        break;

      default:
        break;
    }
  }
  return null;
};
